// import { ICustomer, ICustomerData, IContact, IContactData } from '../../entities'
import {
    IContactRequestHistory,
    IContactRequestHistoryData
} from './contact-request-history'
import {
    ICustomerBase,
    ICustomerBaseData
} from '../customer'

export type ContactRequestStatus = 'new' | 'processing' | 'done'

export interface ICustomerExtendData extends ICustomerBaseData {
    phone?: string
}

export interface IContactRequestBaseData {
    message?: string
}

export interface IContactRequestPostSimpleData extends IContactRequestBaseData, ICustomerExtendData {
}

export interface IContactRequestPostData extends IContactRequestPostSimpleData {
    contact_ways?: number[]
}

export interface IContactRequestData extends IContactRequestBaseData {
    readonly id?: number
    readonly status?: ContactRequestStatus
    readonly history?: IContactRequestHistoryData[]

    // readonly user: ICustomerData
    // readonly contact?: IContactData
}

export interface IContactRequestBase extends IContactRequestBaseData {
    // own fields
    validate(): boolean
}

export interface IContactRequestPostSimple extends IContactRequestPostSimpleData, IContactRequestBase, ICustomerBase {
    // own fields
    validate(): boolean
}

export interface IContactRequestPost extends IContactRequestPostData, IContactRequestPostSimple {
    contact_ways: number[]

    validate(): boolean
}

export interface IContactRequest extends IContactRequestData, IContactRequestBase {
    readonly status: ContactRequestStatus
    readonly history?: IContactRequestHistory[]

    // readonly user: ICustomer
    // readonly contact?: IContact

    validate(): boolean
    getStatus(): (ContactRequestStatus | undefined)
}

export const CONTACT_REQUEST_MESSAGE_MAX_LENGTH = 1000;
export const CONTACT_VALUE_MAX_LENGTH = 50;

